module.exports = "/images/PR_Logo.svg?5268ceb650d6a729c7034189566b5d25";